import { enableProdMode } from '@angular/core';
import { } from '@angular/compiler';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import * as Sentry from '@sentry/angular';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

// for local environment don't turn on Sentry for any logging nor tracing
if (environment.name !== 'default' && environment.name !== 'dev' && environment.name !== 'local' ) {
  Sentry.init({
    dsn: 'https://75794090e88b4d31ad570505ee976abd@o4512283807580160.ingest.sentry.io/4505125554225152',
    environment: environment.name,
    release: environment.version,
    integrations: [
      Sentry.browserTracingIntegration(),
    ],
    initialScope: {
      tags: {
        product: 'Dashboard'
      }
    },

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 0.7,
    enabled: true,

    // ignore errors
    ignoreErrors: [
    ],
    denyUrls: [
      // unreliable service
      /api\.weather\.gov/i,
    ],
  });
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch(err => console.error(err));
